import React from 'react';
import './app/App.css';

const IconMarker = ({ id }) => <div id={`marker-${id}`} className="marker" />;

export default IconMarker;
